  class SynchronizedScrollGallery {
    constructor() {
      this.thumbnailContainer = document.querySelector('.thumbnail-slider');
      this.mainImageContainer = document.querySelector('.main-product-image');
      this.customScrollbar = null;
      this.scrollIndicator = null;
      this.thumbnails = [];
      this.currentImageIndex = 0;

      if (this.thumbnailContainer && this.mainImageContainer) {
        this.init();
      }
    }

    init() {
      this.getThumbnails();
      const needsScrollbar = this.thumbnailContainer.scrollHeight > this.thumbnailContainer.clientHeight;
      if (needsScrollbar && !this.customScrollbar) {
        this.createCustomScrollbar();
      }
      this.bindEvents();
      this.updateScrollIndicator();
      console.log('Gallery initialized with', this.thumbnails.length, 'thumbnails');
    }

    reinitialize() {
      this.unbindEvents();
      if (this.customScrollbar) {
        this.customScrollbar.remove();
        this.customScrollbar = null;
        this.scrollIndicator = null;
      }

      this.init();
    }

    unbindEvents() {
      window.removeEventListener('scroll', this.handleScroll);
      this.thumbnailContainer.removeEventListener('wheel', this.wheelHandler);
      if (this.customScrollbar) this.customScrollbar.removeEventListener('click', this.clickHandler);
      window.removeEventListener('resize', this.resizeHandler);
      this.scrollIndicator?.removeEventListener('mousedown', this.mousedownHandler);
      document.removeEventListener('mousemove', this.mousemoveHandler);
      document.removeEventListener('mouseup', this.mouseupHandler);
    }

    createCustomScrollbar() {
      this.customScrollbar = document.createElement('div');
      this.customScrollbar.className = 'custom-scrollbar';

      this.scrollIndicator = document.createElement('div');
      this.scrollIndicator.className = 'scroll-indicator';

      this.customScrollbar.appendChild(this.scrollIndicator);
      document.body.appendChild(this.customScrollbar);
    }

    getThumbnails() {
      this.thumbnails = this.thumbnailContainer.querySelectorAll('.product-image, .product-single__photo-wrapper');
      console.log('Thumbnails fetched:', this.thumbnails);
    }

    bindEvents() {
      let ticking = false;
      this.handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.handleScrollLogic();
            ticking = false;
          });
          ticking = true;
        }
      };
      window.addEventListener('scroll', this.handleScroll);

      this.wheelHandler = (e) => {
        e.preventDefault();
        this.thumbnailContainer.scrollTop += e.deltaY * 0.5;
        this.updateScrollIndicator();
      };
      this.thumbnailContainer.addEventListener('wheel', this.wheelHandler);

      this.clickHandler = (e) => {
        const rect = this.customScrollbar.getBoundingClientRect();
        const clickY = e.clientY - rect.top;
        const percentage = clickY / rect.height;
        this.jumpToPosition(percentage);
      };
      if (this.customScrollbar) this.customScrollbar.addEventListener('click', this.clickHandler);

      this.makeDraggable();

      this.resizeHandler = () => {
        this.updateScrollIndicator();
        const needsScrollbar = this.thumbnailContainer.scrollHeight > this.thumbnailContainer.clientHeight;
        if (!needsScrollbar && this.customScrollbar) {
          this.customScrollbar.remove();
          this.customScrollbar = null;
          this.scrollIndicator = null;
        } else if (needsScrollbar && !this.customScrollbar) {
          this.createCustomScrollbar();
        }
      };
      window.addEventListener('resize', this.resizeHandler);
    }

    makeDraggable() {
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

      this.mousedownHandler = (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = this.thumbnailContainer.scrollTop;
        document.body.style.userSelect = 'none';
        this.scrollIndicator.style.transition = 'none';
      };
      this.scrollIndicator?.addEventListener('mousedown', this.mousedownHandler);

      this.mousemoveHandler = (e) => {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const scrollbarHeight = this.customScrollbar.offsetHeight;
        const maxScroll = this.thumbnailContainer.scrollHeight - this.thumbnailContainer.clientHeight;

        const scrollDelta = (deltaY / scrollbarHeight) * maxScroll;
        const newScrollTop = Math.max(0, Math.min(maxScroll, startScrollTop + scrollDelta));

        this.thumbnailContainer.scrollTop = newScrollTop;
        this.updateScrollIndicator();
      };
      document.addEventListener('mousemove', this.mousemoveHandler);

      this.mouseupHandler = () => {
        if (isDragging) {
          isDragging = false;
          document.body.style.userSelect = '';
          this.scrollIndicator.style.transition = 'all 0.2s ease';
        }
      };
      document.addEventListener('mouseup', this.mouseupHandler);
    }

    handleScrollLogic() {
      if (!this.mainImageContainer || !this.thumbnailContainer) return;

      const mainImageRect = this.mainImageContainer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const scrollTop = window.pageYOffset;

      const mainImageTop = mainImageRect.top + scrollTop;
      const mainImageBottom = mainImageTop + mainImageRect.height;

      let scrollPercentage;
      if (scrollTop >= mainImageTop && scrollTop <= mainImageBottom - windowHeight) {
        const scrollInImageArea = scrollTop - mainImageTop;
        const imageAreaHeight = mainImageRect.height - windowHeight;
        scrollPercentage = Math.max(0, Math.min(1, scrollInImageArea / imageAreaHeight));
      } else if (scrollTop < mainImageTop) {
        scrollPercentage = 0;
      } else {
        scrollPercentage = 1;
      }

      this.syncThumbnailScroll(scrollPercentage);
      this.updateCurrentImageIndex(scrollPercentage);
      this.updateScrollIndicator();
    }

    syncThumbnailScroll(scrollPercentage) {
      const maxScrollTop = this.thumbnailContainer.scrollHeight - this.thumbnailContainer.clientHeight;
      const targetScrollTop = maxScrollTop * scrollPercentage;
      this.thumbnailContainer.scrollTop = targetScrollTop;
    }

    updateCurrentImageIndex(scrollPercentage) {
      if (this.thumbnails.length === 0) return;

      this.currentImageIndex = Math.floor(scrollPercentage * (this.thumbnails.length - 1));
      this.currentImageIndex = Math.max(0, Math.min(this.thumbnails.length - 1, this.currentImageIndex));
    }

    updateScrollIndicator() {
      if (!this.scrollIndicator || this.thumbnails.length === 0) return;

      const thumbnailRect = this.thumbnailContainer.getBoundingClientRect();
      const containerTop = thumbnailRect.top;
      const containerHeight = thumbnailRect.height;

      this.customScrollbar.style.top = `${containerTop}px`;
      this.customScrollbar.style.height = `${containerHeight}px`;

      const totalItems = this.thumbnails.length;
      const indicatorHeight = Math.max(20, containerHeight / totalItems);

      const maxScroll = this.thumbnailContainer.scrollHeight - this.thumbnailContainer.clientHeight;
      const scrollPercentage = maxScroll > 0 ? this.thumbnailContainer.scrollTop / maxScroll : 0;

      const maxTop = containerHeight - indicatorHeight;
      const indicatorTop = maxTop * scrollPercentage;

      this.scrollIndicator.style.height = `${indicatorHeight}px`;
      this.scrollIndicator.style.top = `${indicatorTop}px`;
    }

    jumpToPosition(percentage) {
      const maxScroll = this.thumbnailContainer.scrollHeight - this.thumbnailContainer.clientHeight;
      const targetScroll = maxScroll * percentage;
      this.animateScrollTo(targetScroll);
    }

    animateScrollTo(targetScroll) {
      const startScroll = this.thumbnailContainer.scrollTop;
      const distance = targetScroll - startScroll;
      const duration = 300; // ms
      let startTime = null;

      const animation = (currentTime) => {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);

        const easeOut = 1 - Math.pow(1 - progress, 3);

        this.thumbnailContainer.scrollTop = startScroll + (distance * easeOut);
        this.updateScrollIndicator();

        if (progress < 1) {
          requestAnimationFrame(animation);
        }
      };

      requestAnimationFrame(animation);
    }

    jumpToThumbnail(index) {
      if (index < 0 || index >= this.thumbnails.length) return;

      const percentage = index / (this.thumbnails.length - 1);
      this.jumpToPosition(percentage);
    }

    handleResize() {
      this.updateScrollIndicator();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const gallery = new SynchronizedScrollGallery();

    window.addEventListener('resize', () => {
      gallery.handleResize();
    });

    window.galleryInstance = gallery;

    const modelButtons = document.querySelectorAll('.modelnav li');
    modelButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        gallery.reinitialize();
      });
    });
  });

	jQuery(document).ready(function($) {

		var $productImageWrapper = $('#product-photo-thumbs .product-image');
		var productTitle = $('.product-single__title').text();
		var modelNavs = ["All"];
		var modelCount = 0;

		$productImageWrapper.each( function (idx, el) {
			var $img = $(el).find('img');
			var imageAlt = $img.attr('alt');
			var altHasModel = false;
			var modelExisted = false;
			var modelClass;
      // console.log('---> productImageWrapper ' + imageAlt);

			if (imageAlt.indexOf('[') != -1) {
				altHasModel = true;
				var altParts = imageAlt.split('[');
				imageAlt = altParts[0];
				$img.attr('alt', imageAlt);
				// console.log('---> has model ' + imageAlt);

	
				var modelParts = altParts[1].split(']');
				modelAlt = modelParts[0].replace(' ', ',&nbsp;');
	
				modelClass = modelAlt.replace(' ', '-').replace('/', '-').replace('&nbsp;', '-').replace(',', '').replace('+', 'plus').toLowerCase();
				$img.attr('data-model', modelClass);

        console.log(modelClass);
	
				for (var i=0; i<modelNavs.length; i++) {
					if (modelNavs[i] == modelAlt) {
						modelExisted = true;
					}
				}
				if (!modelExisted) {
					modelCount++;
					$('.modelnav').append('<li data-model="' + modelClass + '">' + modelAlt + '</li>');
				
					if (modelCount > 1)
						$('.modelnav').css('opacity', 1);

					modelNavs.push(modelAlt);
				}
			}
			$(el).addClass(modelClass);
		});

		$('.modelnav li').click(function() {
			var model = $(this).data('model');

			//if ($(window).width() <= 768) {
				//$('.desktop-slider').slick('slickUnfilter');
				//$('.desktop-slider').slick('refresh');
			//} else {
				//$('.desktop-slider').slick('slickUnfilter');
				//$('.desktop-slider-nav').slick('slickUnfilter');
				//$('.desktop-slider').slick('refresh');
				//$('.desktop-slider-nav').slick('refresh');
 			//}
		
			// show all or hide all, depending
			if (model == "all" || $(this).hasClass('active')) {
				$('.modelnav li').removeClass('active');
			} else {
				$('.modelnav li').removeClass('active');
				$('.modelnav li[data-model="' + model + '"]').addClass('active');
        $('.modelnav li[data-model="' + model + '"]').parents('media-gallery').removeClass().addClass(model);
        $('.desktop-slider .product-single__photo-wrapper').hide();
        $('.desktop-slider .product-single__photo-wrapper[data-model^="' + model + '"]').show();
        $('.desktop-slider-nav .product-image').hide();
        $('.desktop-slider-nav .product-image[data-model^="' + model + '"]').show();
				// filter sliders
		    // console.log(' filter sliders: ' + model);
				// var classy = '.' + model;
				
				// if ($(window).width() <= 768) {
				// 	$('.desktop-slider').slick('slickFilter', classy);
				// 	$('.desktop-slider').slick('refresh');
				// } else {
				// 	$('.desktop-slider').slick('slickFilter', classy);
				// 	$('.desktop-slider-nav').slick('slickFilter', classy);
				// 	$('.desktop-slider').slick('refresh');
				// 	$('.desktop-slider-nav').slick('refresh');
				// }
			}
		
			$('html, body').animate({
				scrollTop: 0
			}, 600);
		});

		$('.mobile-slider').slick({
			arrows         : false,
			dots           : true,
			adaptiveHeight : false,
      dotsClass: 'slick-dot'
		});
		// $('.desktop-slider').slick({
		// 	arrows         : false,
		// 	dots           : true,
		// 	{% if product.media.size > 5 %}
		// 		asNavFor : '.desktop-slider-nav',
		// 	{% endif %}
		// 	adaptiveHeight : false,
    //   dotsClass: 'slick-dot'
    // }).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    //   // Update slick-current for second
    //   $('.desktop-slider-nav .slick-slide').removeClass('slick-current');
    //   $('.desktop-slider-nav .slick-slide[data-slick-index="' + nextSlide + '"]').addClass('slick-current');
    // });

    // New product gallery mobile slider
    let sliderInitialized = false;

    function initSlider() {
      const $mainSlider = $('.desktop-slider');

      if ($(window).width() <= 767) {
        if (!sliderInitialized) {
          $mainSlider.slick({
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            dotsClass: 'slick-dot'
          });

          sliderInitialized = true;
        }
      } else {
        if (sliderInitialized && $mainSlider.hasClass('slick-initialized')) {
          $mainSlider.slick('unslick');
          sliderInitialized = false;
        }
      }
    }

    $(window).on('resize', initSlider);

    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    $(document).ready(function() {
      initSlider();
      
      //$(window).on('resize', debounce(initSlider, 300));
    });
   // End new product gallery mobile slider

    // var sliderProduct = function() {
    //   if ($(window).width() <= 590) {
    //     if ($('.desktop-slider-nav').hasClass('slick-initialized')) {
    //       $('.desktop-slider-nav').slick('unslick');
    //     }
    //     $('.desktop-slider-nav').slick({
    //       arrows: true,
    //       dots: false,
    //       vertical		: false,
    //       verticalSwiping	: false,
    //       slidesToShow	: 5,
    //       slidesToScroll	: 1,
    //       centerMode: false,
    //       focusOnSelect	: true,
    //       centerPadding: '0px',
    //       prevArrow: `<button type="button" class="slick-prev">
    //         <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <g transform="rotate(180, 9, 9)">
    //             <path d="M7.02881 3L13.0578 9.02902L7.02881 15.058" stroke="#ECF3F9" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round"/>
    //           </g>
    //         </svg>
    //       </button>`,
    //       nextArrow: `<button type="button" class="slick-next">
    //         <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    //           <path d="M7.02881 3L13.0578 9.02902L7.02881 15.058" stroke="#ECF3F9" stroke-width="2" stroke-miterlimit="20" stroke-linecap="round" stroke-linejoin="round"/>
    //         </svg>
    //       </button>`,
    //       asNavFor : '.desktop-slider',
    //       rows: 1, 
    //       slidesPerRow: 1,
    //       adaptiveHeight: false,
    //       swipe: true,
    //       touchMove: true,
    //       draggable: true
    //     });
    //   } else {
    //     // $('.desktop-slider-nav').slick({
    //     //   arrows      	: {% if product.media.size > 5 %}true{% else %}false{% endif %},
    //     //   dots        	: false,
    //     //   vertical		: true,
    //     //   verticalSwiping	: true,
    //     //   {% if product.media.size > 5 %}
    //     //     infinite : true, 
    //     //   {% endif %}
    //     //   asNavFor		: '.desktop-slider',
    //     //   slidesToShow	: 5,
    //     //   slidesToScroll	: 1,
    //     //   centerMode		: true,
    //     //   focusOnSelect	: true,
    //     //   dotsClass: 'slick-dot'
    //     // });
    //   }
    // }
    // sliderProduct();
    // $(window).resize(function() {
    //   sliderProduct();
    // });

		// if ($(window).width() >= 591) {
    //   var $imageZoom = $('.image-zoom');
    //   $imageZoom.each( function (idx, el) {
    //     $(el).wrap('<span style="display:inline-block"></span>')
    //       .css('display', 'block')
    //       .parent()
    //       .zoom({
    //         url: $(this).attr('data-zoom'),
    //         on: 'click',
    //         onZoomIn: function() { $('#product-photo-container').addClass('zoomed'); },
    //         onZoomOut: function() { $('#product-photo-container').removeClass('zoomed'); }
    //     });
    //   })
		// };
    
	});
